
import img1 from "../../assets/images/pm-Image 3.jpg";


import img3 from "../../assets/images/pm-Image 7.jpg";
// import img2 from "../../assets/images/pm-Image 2.jpg";
// import img5 from "../../assets/images/pm-image 5.jpg";

import img2 from "../../assets/images/pm-Image 6.jpg";
// import img1 from "../../assets/images/pm-Image 1.jpg";
import img4 from '../../assets/images/wimg.jpeg'
import img5 from '../../assets/images/wimg2.jpeg'
import img6 from '../../assets/images/wimg3.jpeg'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // basic Swiper styles
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Autoplay } from "swiper/modules";

const PmSlider = () => {


    function ImageSlide({ src }) {
        const imageStyle = {
            // width: "100%",
            // height: "500px",
            objectFit: "contain",
            borderRadius: "8px",
            // padding:'15px'
        };

        const imageContainerStyle = {
            padding: "0 7.5px",
            boxSizing: "border-box",
            width: "100%",
            height: "500px",
        };

        return (
            <div style={imageContainerStyle}>
                <img
                    className="slider-image"
                    src={src}
                    alt="Slider"
                    style={imageStyle}
                    width={600} height={600}
                />
            </div>
        );
    }


    return (
        <section className=" text-center container">
            <div className="row py-5" style={{ overflowX: 'hidden' }}>
                <div className="col-lg-12 col-md-10 py-2  mx-auto text-center">
                    <h2 className="TextRes" style={{ position: 'relative', color: 'black' }}>
                        <span style={{ fontSize: "55px", position: 'absolute', top: '-15px', left: '50%', transform: 'translateX(-50%)', borderBottom: '2px solid #faab04', width: '50px' }}></span>
                        Launch Event and {' '}
                        <span style={{ color: "#a20000" }}>
                            Media Coverage
                        </span>
                    </h2>
                </div>
            </div>

            <div>
                <p style={{ fontSize: "18px", fontWeight: '400' }}>
                    We recently held <span style={{ color: "#a20000" }}>“Gautam Solar Tech Workshop and Press Conference”</span> “Gautam Solar Tech Workshop and Press Conference” in Jaipur, Rajasthan on 28th June 2024 to launch this comprehensive technical whitepaper. The event received significant media attention, highlighting our commitment to supporting farmers and solar power developers. Check out some snippets of the media coverage.
                </p>
            </div>

            <div className="py-5 row justify-content-center">
                <div className="col-lg-12 col-md-12 position-relative slider-container">

                    <Swiper
                        slidesPerView={1}
                        spaceBetween={20}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            1200: { slidesPerView: 3 },
                            992: { slidesPerView: 3 },
                            768: { slidesPerView: 2 },
                            576: { slidesPerView: 2 },
                        }}
                        loop={true}
                        modules={[Autoplay]}
                        className="mySwiper overflow-hidden"
                    >
                        <SwiperSlide><ImageSlide src={img1} /></SwiperSlide>
                        <SwiperSlide><ImageSlide src={img2} /></SwiperSlide>
                        <SwiperSlide><ImageSlide src={img3} /></SwiperSlide>
                        <SwiperSlide><ImageSlide src={img4} /></SwiperSlide>
                        <SwiperSlide><ImageSlide src={img5} /></SwiperSlide>
                        <SwiperSlide><ImageSlide src={img6} /></SwiperSlide>
                    </Swiper>
                </div>


            </div>
        </section>
    );
}


export default PmSlider;
